export default __webpack_public_path__ + "static/media/acceleY.c46974ee.svg";